import React, { forwardRef } from 'react'
import { StyledMenuItem } from '../styled'
import { MenuItemPanel } from './MenuItemPanel'

export const MenuItem = forwardRef((props, ref) => {
  return (
    <StyledMenuItem ref={ref} onClick={props.toggleOpen} $open={props.open}>
      <a href={props.href} data-theme={props.theme ?? 'default'}>
        {props.name}
        {props.afterText && <span>{props.afterText}</span>}
      </a>
      {props.links && props.links.length > 0 && (
        <MenuItemPanel
          links={props.links}
          defaultLinks={props.defaultLinks}
          posters={props.posters}
        />
      )}
    </StyledMenuItem>
  )
})